var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        "min-height": "62px",
        "border-radius": "8px",
        display: "flex",
        "flex-direction": "column",
        padding: "15px"
      },
      style: {
        "background-color": _vm.uploadFailed
          ? "var(--stan-negative-light-color)"
          : "var(--stan-gray-soft-color)"
      }
    },
    [
      _vm.generatedBy
        ? _c("div", { staticClass: "generated-file-info" }, [
            _c("div", { staticClass: "generated-message" }, [
              _vm._v(
                "\n\t\t\tStanley generated this file. To make changes, you can download it and edit it in Canva before re-uploading.\n\t\t"
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "learn-more-link",
                on: { click: _vm.handleLearnMore }
              },
              [_vm._v("\n\t\t\tLearn More\n\t\t")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "main-content-row" }, [
        _c(
          "div",
          { staticClass: "file-name-icon-container" },
          [
            _vm.isUploading
              ? _c("InlineSvg", {
                  staticClass: "status-icon rotating",
                  attrs: { src: "/images/icons/ic-reload.svg" }
                })
              : _vm.isErrored
              ? _c("InlineSvg", {
                  staticClass: "status-icon",
                  attrs: {
                    src: "/images/icons/ic-warning-circle-filled-negative.svg"
                  }
                })
              : _vm.generatedBy
              ? _c("InlineSvg", {
                  staticClass: "status-icon generated-icon",
                  attrs: { src: "/images/icons-2025/ai-inform.svg" }
                })
              : _c("InlineSvg", {
                  staticClass: "status-icon",
                  attrs: {
                    src: "/images/icons/ic-check-circle-filled-positive.svg"
                  }
                }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "para-2 text-bold file-name",
                class: {
                  "text-light": _vm.isUploading,
                  "stan-text-danger": _vm.uploadFailed
                }
              },
              [_vm._v(_vm._s(_vm.fileName))]
            ),
            _vm._v(" "),
            _vm.isUploading
              ? _c("InlineSvg", {
                  staticClass: "delete-file-icon",
                  attrs: { src: "/images/icons/ic-trash.svg" },
                  on: { click: _vm.deleteFile }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.isUploading
          ? _c("div", { staticClass: "para-3 text-light" }, [
              _c("span", { staticClass: "text-bold" }, [
                _vm._v("Uploading...")
              ]),
              _vm._v(" (" + _vm._s(_vm.uploadProgress) + "%)")
            ])
          : _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  gap: "10px",
                  "align-items": "center"
                }
              },
              [
                _vm.uploadFailed
                  ? _c(
                      "span",
                      { staticClass: "para-3 stan-text-danger text-bold" },
                      [_vm._v("\n\t\t\t\tFailed to upload\n\t\t\t")]
                    )
                  : !_vm.isUrl
                  ? _c(
                      "AppButton",
                      {
                        attrs: {
                          name: "download-uploaded-product",
                          size: "sm",
                          outline: true,
                          icon: "/images/icons/ic-digital-download.svg"
                        },
                        on: { click: _vm.downloadFile }
                      },
                      [_vm._v("\n\t\t\t\tDownload\n\t\t\t")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editNotDelete
                  ? _c("InlineSvg", {
                      staticClass: "delete-file-icon",
                      attrs: { src: "/images/icons/ic-trash.svg" },
                      on: { click: _vm.deleteFile }
                    })
                  : _c("InlineSvg", {
                      staticClass: "delete-file-icon",
                      attrs: { src: "/images/icons/ic-edit.svg" },
                      on: { click: _vm.editFile }
                    })
              ],
              1
            )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }